var map = {
	"./Antje_Lier_2025.jpg": "3f93",
	"./Biermann2019.jpg": "e657",
	"./Candy_Huster_2025.jpg": "93e0",
	"./Doll2020.jpg": "14dd",
	"./Jimenez2022.jpg": "37f9",
	"./Kaehler2019.jpg": "688b",
	"./Klimpel-Hildebrandt2019.jpg": "50b6",
	"./Koehler2020.jpg": "954d",
	"./Kolja_Wiekhorst_2025.jpg": "114f",
	"./Kretschmer2022.jpg": "70c3",
	"./Lauffs2019.jpg": "ff95",
	"./Milan_Jarosch_2025.jpg": "b395",
	"./Peter_Hofmann_2025.jpg": "af44",
	"./Schmidt2025.jpg": "992d",
	"./Streckert2019.jpg": "91b0",
	"./Sven_Wiltsch_2025.jpg": "b1ce",
	"./Tobola2019.jpg": "f2c7",
	"./placeholder3.jpg": "056f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09f3";